import { Button, Modal } from '@/components';
import { usePermissions } from '@/common/hooks';
import { useCompanyPreferences } from '../hooks/useCompanyPreferences';
import { CompanyPreferencesSetupModal } from './CompanyPreferencesSetupModal';

function PreferencesRetryModal({ error, isFetching, onRetry }) {
  const message =
    error?.response?.data?.detail ||
    error?.response?.data?.message ||
    error?.message ||
    'Failed to load preferences.';

  return (
    <Modal
      isOpen
      showClose={false}
      size="sm"
      title="Couldn't load preferences"
      description="Country and currency are required before you can continue."
      footer={
        <Button
          variant="primary"
          onClick={onRetry}
          disabled={isFetching}
          className="px-5 py-2.5 h-[40px] text-[14px] font-medium rounded-lg"
        >
          {isFetching ? 'Retrying...' : 'Retry'}
        </Button>
      }
    >
      <p className="text-[15px] text-text-muted">{message}</p>
    </Modal>
  );
}

export function CompanyPreferencesGate({ companyId }) {
  const { role } = usePermissions();
  const isOwner = String(role || '').toLowerCase() === 'owner';
  const {
    preferences,
    isComplete,
    isPending,
    isFetching,
    isError,
    error,
    refetch,
    update,
    isUpdating,
  } = useCompanyPreferences(companyId);

  if (!companyId || !isOwner || isPending) return null;

  if (isError) {
    if (error?.response?.status === 403) return null;
    return (
      <PreferencesRetryModal
        error={error}
        isFetching={isFetching}
        onRetry={() => refetch()}
      />
    );
  }

  if (!isComplete) {
    return (
      <CompanyPreferencesSetupModal
        isOpen
        preferences={preferences}
        isUpdating={isUpdating}
        onSave={update}
      />
    );
  }

  return null;
}
